import React, { Component } from 'react';

export class Events extends Component {
  static displayName = Events.name;

  render () {
    return (
      <div>
        <section className="events-container">
            <div className="event-card">
                <div className="event-image">
                <img src="/images/event1.jpg" alt="Kumbh Mela 1942" />
                </div>
                <div className="event-content">
                <h3>Kumbh Mela – Prayagraj (1942)</h3>
                <div className="event-meta">
                    <span>📅 1942</span> <span>📍 Prayagraj</span>
                </div>
                <p className="event-desc">
                    Guruji presided over a grand spiritual assembly during the Kumbh
                    Mela, inspiring seekers towards the path of Sanatan Dharma and
                    self-realization.
                </p>
                </div>
            </div>

            <div className="event-card">
                <div className="event-image">
                <img src="/images/event2.jpg" alt="Varanasi Sabha" />
                </div>
                <div className="event-content">
                <h3>Spiritual Sabha — Varanasi</h3>
                <div className="event-meta">
                    <span>📅 1946</span> <span>📍 Varanasi</span>
                </div>
                <p className="event-desc">
                    A historic gathering where Guruji shared deep wisdom on Vedanta and
                    guided thousands of followers toward spiritual discipline and
                    meditation.
                </p>
                </div>
            </div>

            <div className="event-card">
                <div className="event-image">
                <img src="/images/event3.jpg" alt="Rameshwaram Yatra" />
                </div>
                <div className="event-content">
                <h3>Rameshwaram Yatra</h3>
                <div className="event-meta">
                    <span>📅 1950</span> <span>📍 Rameshwaram</span>
                </div>
                <p className="event-desc">
                    Guruji led a sacred pilgrimage to Rameshwaram with hundreds of
                    devotees, performing special Vedic rituals and spreading the message
                    of dharma and peace.
                </p>
                </div>
            </div>

            <div className="event-card">
                <div className="event-image">
                <img src="/images/event4.jpg" alt="Inauguration of Ashram" />
                </div>
                <div className="event-content">
                <h3>Inauguration of Jyotirmath Ashram</h3>
                <div className="event-meta">
                    <span>📅 1941</span> <span>📍 Uttarakhand</span>
                </div>
                <p className="event-desc">
                    The revival of the ancient Jyotirmath Peeth was a milestone in
                    Guruji’s divine mission, reinstating the sacred lineage of Adi
                    Shankaracharya.
                </p>
                </div>
            </div>

        </section>
      </div>
    );
  }
}